import { createResource, type RouteResource } from 'react-resource-router';

import type { GetTimeTemplatesResponse, GetTimezonesResponse } from '../../common/types/time';
import { endpoints as timeEndpoints } from '../endpoints/time';

const getTimezonesResource: RouteResource<GetTimezonesResponse> = createResource({
	type: 'getEocTimezonesResource',
	getKey: () => 'getEocTimezonesResource',
	isBrowserOnly: true,
	getData: async () => timeEndpoints.getTimezones(),
});

const getTimeTemplatesResource: RouteResource<GetTimeTemplatesResponse> = createResource({
	type: 'getEocTimeTemplatesResource',
	getKey: () => 'getEocTimeTemplatesResource',
	isBrowserOnly: true,
	getData: async () => timeEndpoints.getTimeTemplates(),
});

const resources = [getTimezonesResource];

export type { GetTimezonesResponse, GetTimeTemplatesResponse };

export { getTimezonesResource, getTimeTemplatesResource, resources };
